import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-sl-files',
  standalone: false,
  templateUrl: './sl-files.component.html',
  styleUrl: './sl-files.component.css'
})
export class SlFilesComponent implements OnInit {

  slfiles: any[] = [];
  files: any[] = [];
  treeNodes: any[] = [];
  loading = false;
  type: string = "";
  header: string = "";
  constructor(
    private institutionService: InstitutionsService,
    private messageService: MessageService,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe(params => {
      this.type = params['type'];
      this.header = this.type === "1" ? "Medlemsantal månadsslut" : "Medlemsantal - SL-avgift årsavräkning";
      this.loadFiles();
    });
  }

  ngOnInit(): void {
    //this.loadFiles();
  }

  loadFiles(): void {
    this.loading = true;

    this.institutionService.GetSLLists().subscribe({
      next: (files:any) => {
        this.files = files;
       
       /* if (this.type === "1") {
          this.files = this.files.filter(file => file.reportType == 'Månadsvis');
        } else {
          this.files = this.files.filter(file => file.reportType != 'Månadsvis');
        }*/
    
        this.treeNodes = this.buildTree(this.files);
        this.loading = false;
      },
      error: (error:any) => {
        console.error('Kunde inte hämta filer', error);
        this.loading = false;
      }
    });
  }

  private buildTree(files: any[]): any[] {
  const years = new Map<number, any>();
  for (const file of files) {
    const withdrawalDate =
      new Date(file.withdrawalDate);
    const year =
      withdrawalDate.getFullYear();
    // ==========================================
    // ÅR
    // ==========================================

    let yearNode = years.get(year);

    if (!yearNode) {

      yearNode = {

        key: `year-${year}`,

        data: {
          type: 'year',
          year: year
        },

        children: [],

        leaf: false,

        expanded: false
      };

      years.set(
        year,
        yearNode
      );
    }


    // ==========================================
    // RAPPORT
    // ==========================================

    const reportKey =
      `${year}-${file.withdrawalDate}-${file.reportType}`;


    let reportNode =
      yearNode.children.find(
        (x: any) =>
          x.key === reportKey
      );


    if (!reportNode) {

      reportNode = {

        key: reportKey,

        data: {

          type: 'report',

          periodDate:
            file.periodDate,

             withdrawalDate:
            file.withdrawalDate,

          reportType:
            file.reportType
        },

        children: [],

        leaf: false,

        expanded: false
      };


      yearNode.children.push(
        reportNode
      );
    }

    // =========================================
    // FIL
    // ==========================================

    reportNode.children.push({
      key: `file-${file.id}`,
      data: {
        type: 'file',
        fileId:
          file.id,
        fileName:
          file.fileName
      },
      leaf: true
    });
  }

  // ==========================================
  // SORTERA ÅR
  // ==========================================

  return Array.from(
    years.values()
  )
  .sort(
    (a, b) =>
      b.data.year -
      a.data.year
  );
}

      downloadFile(fileId: string, fileName: string): void {

  this.institutionService
    .download(fileId)
    .subscribe({
      next: (blob: Blob) => {

        const url =
          window.URL.createObjectURL(blob);

        const a =
          document.createElement('a');

        a.href = url;

        a.download =
          fileName.trim();

        document.body.appendChild(a);

        a.click();

        document.body.removeChild(a);

        window.URL.revokeObjectURL(url);
        this.messageService.add({ severity: 'success', summary: 'Information', detail: fileName + ' har laddats ner.' });
      },

      error: (error: any) => {

        console.error(
          'Kunde inte ladda ner filen',
          error
        );

      }
    });
}

getReportName(rowData: any): string {

  const withdrawalDate = new Date(rowData.withdrawalDate);
let rubrik = "";
  switch (rowData.reportType) {
    case 'Månadsvis':
      rubrik = `${withdrawalDate.getFullYear()}-${String(withdrawalDate.getMonth() + 1).padStart(2, '0')}`;
      break;
    case 'Q1Q3':
      rubrik = 'Kvartal 1-3 prel. debitering ' + withdrawalDate.getFullYear();
      break;
    case 'Annual': 
      rubrik = 'Årsavräkning ' + withdrawalDate.getFullYear();
      break;
    case 'Q4':
      rubrik = 'Kvartal 4 - årsavräkning ' + withdrawalDate.getFullYear();
      break;
  }
  return rubrik;
}

}
